import { Input, Menu } from 'antd';
import clsx from 'clsx';
import React, { useEffect } from 'react';
import { FaRegUserCircle, FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { selectUserInfo } from '../../Layout/homeSlice';
import MenuItem from './MenuItem';
import style from './sidebar.module.scss';
import {
  selectInverterItemSidebar,
  selectPlantItemSidebar,
  selectSidebarList,
  sidebarActions,
} from './sidebarSlice';

export default function Sidebar() {
  const userInfo = useAppSelector(selectUserInfo);
  const plantList = useAppSelector(selectSidebarList);
  const plantItemSelected = useAppSelector(selectPlantItemSidebar);
  const inverterItemSelected = useAppSelector(selectInverterItemSidebar);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (userInfo !== undefined) {
      dispatch(sidebarActions.fetchSidebarList(userInfo.id));
    }
    const plantId = localStorage.getItem('plantItemSidebar');
    const inverterId = localStorage.getItem('inverterItemSidebar');
    if (plantId === '') {
      dispatch(sidebarActions.setPlantItemSidebarList(null));
    } else {
      dispatch(sidebarActions.setPlantItemSidebarList(plantId));
    }
    if (inverterId === '') {
      dispatch(sidebarActions.setInverterItemSidebarList(null));
    } else {
      dispatch(sidebarActions.setInverterItemSidebarList(inverterId));
    }
  }, [dispatch, userInfo]);

  const handleUserSidebarClick = () => {
    localStorage.setItem('plantItemSidebar', '');
    localStorage.setItem('inverterItemSidebar', '');
    localStorage.setItem('isValueNavUser', '1');
    dispatch(sidebarActions.setPlantItemSidebarList(null));
  };

  return (
    <div className={style.root}>
      <div className={style.top_section}>
        <div className={style.logo_title}>SolarFarm</div>
      </div>
      <div className={style.search_controller}>
        <Input size="large" placeholder="Search" prefix={<FaSearch />} />
      </div>
      <div className={style.sidebarList} id={style.style_4}>
        <Link key="user" to={`/user/home`}>
          <div
            className={clsx(style.menuItem, {
              [style.active]: plantItemSelected === null && inverterItemSelected === null,
            })}
            onClick={handleUserSidebarClick}
            style={{
              marginBottom: '10px',
            }}
          >
            <FaRegUserCircle size="15px" />
            <div className={style.menuItemLabel}>User</div>
          </div>
        </Link>
        <Menu>
          {plantList?.map((menuItem) => (
            <MenuItem menuItem={menuItem} key={menuItem.id} />
          ))}
        </Menu>
      </div>
    </div>
  );
}
